<template>
  <div class="rapport-standard-container">
    <v-textarea auto-grow rows="1" outlined label="Titel" v-model="title"></v-textarea>
    <v-textarea auto-grow rows="1" outlined label="Puffrubrik" v-model="preamble"></v-textarea>
    <v-textarea auto-grow rows="1" outlined label="Pufftext" v-model="description"></v-textarea>
  </div>
</template>

<script>
export default {
  name: 'RapportStandard',
  props: {
    article_title: { type: String },
    article_sub_title: { type: String },
    article_description: { type: String },
  },
  computed: {
    title: {
      get() {
        return this.article_title
      },
      set(val) {
        this.$emit('update', { article_title: val })
      },
    },
    preamble: {
      get() {
        return this.article_sub_title
      },
      set(val) {
        this.$emit('update', { article_sub_title: val })
      },
    },
     description: {
      get() {
        return this.article_description
      },
      set(val) {
        this.$emit('update', { article_description: val })
      },
    },
  },
}
</script>

<style lang="less" scoped>
.rapport-standard-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
}
</style>
